module.exports = __webpack_public_path__ + "static/media/roster.f182a78f.svg";